import React from 'react'
import './CSS/LoginSignup.css'
import {
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth'
import { auth, authPersistence } from '../firebase'

const LoginSignup = () => {

  const handleGoogleLogin = async () => {

    const provider = new GoogleAuthProvider()

    try {
      await authPersistence

      const result = await signInWithPopup(auth, provider)

      console.log('Google login successful:', result.user)

      window.location.replace('/')

    } catch (error) {

      console.error('Google login error:', error)

      alert('Google login failed: ' + error.message)

    }

  }

  return (
    <div className='loginsignup'>

      <div className='loginsignup-container'>

        <div className='loginsignup-brand'>
          <span>BadtameezDil</span>
          <strong>GameStore</strong>
        </div>

        <h1>Welcome Back</h1>

        <p className='loginsignup-subtitle'>
          Sign in to continue to BadtameezDil GameStore
        </p>

        <button
          className='google-login-button'
          onClick={handleGoogleLogin}
        >
          <svg
            className='google-icon'
            viewBox='0 0 24 24'
            aria-hidden='true'
          >
            <path
              fill='#4285F4'
              d='M21.35 12.27c0-.72-.06-1.42-.18-2.09H12v3.96h5.22a4.47 4.47 0 0 1-1.94 2.93v2.45h3.14c1.84-1.69 2.93-4.18 2.93-7.25z'
            />
            <path
              fill='#34A853'
              d='M12 21.65c2.63 0 4.84-.87 6.45-2.35l-3.14-2.45c-.87.58-1.98.92-3.31.92-2.54 0-4.69-1.72-5.46-4.03H3.3v2.53A9.75 9.75 0 0 0 12 21.65z'
            />
            <path
              fill='#FBBC05'
              d='M6.54 13.74A5.86 5.86 0 0 1 6.23 12c0-.61.11-1.2.31-1.74V7.73H3.3A9.75 9.75 0 0 0 2.25 12c0 1.57.38 3.05 1.05 4.27l3.24-2.53z'
            />
            <path
              fill='#EA4335'
              d='M12 6.23c1.43 0 2.71.49 3.72 1.45l2.79-2.79C16.84 3.3 14.63 2.35 12 2.35a9.75 9.75 0 0 0-8.7 5.38l3.24 2.53C7.31 7.95 9.46 6.23 12 6.23z'
            />
          </svg>

          <span>Continue with Google</span>
        </button>

        <p className='loginsignup-agreement'>
          By continuing, you agree to our terms of use and privacy policy.
        </p>

      </div>

    </div>
  )
}

export default LoginSignup

